/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Unpublish1Inputs */

const vi_cmspost_unpublish1 = /** @type {(inputs: Cmspost_Unpublish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gỡ khỏi web`)
};

/**

* @param {Cmspost_Unpublish1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_unpublish1 = /** @type {((inputs?: Cmspost_Unpublish1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Unpublish1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_unpublish1(inputs)
});
export { cmspost_unpublish1 as "cmsPost_unpublish" }